export default __webpack_public_path__ + "static/media/carousel_3.2be7e027.jpg";